import React from 'react';
import { Tabs, Tab, Box, Paper } from '@mui/material';
import i18next from 'i18next';
import EarlybirdTab from './reports/earlybirdTab';
import StatisticsTab from './reports/statisticsTab';
import RequestsTab from './reports/requestsTab';
import HotelContractsTab from './reports/hotelContractsTab';
import ContactOverviewTab from './reports/contactOverviewTab';
import ContactPersonReportTab from './reports/contactPersonReportTab';

export default function ReportPage() {
  const [tab, setTab] = React.useState(0);

  return (
    <Paper>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} aria-label={String(i18next.t('reports-page-tabs-aria'))}>
          <Tab label={String(i18next.t('bericht-tab-earlybird'))} />
          <Tab label={String(i18next.t('bericht-tab-statistics'))} />
          <Tab label={String(i18next.t('bericht-tab-requests'))} />
          <Tab label={String(i18next.t('bericht-tab-hotel-contracts'))} />
          <Tab label={String(i18next.t('bericht-tab-contact-overview'))} />
          <Tab label={String(i18next.t('bericht-tab-contact-persons'))} />
        </Tabs>
      </Box>
      <Box sx={{ p: 2 }}>
        {tab === 0 && <EarlybirdTab />}
        {tab === 1 && <StatisticsTab />}
        {tab === 2 && <RequestsTab />}
        {tab === 3 && <HotelContractsTab />}
        {tab === 4 && <ContactOverviewTab />}
        {tab === 5 && <ContactPersonReportTab />}
      </Box>
    </Paper>
  );
}